import { MAX_POLLING_DURATION_MS } from '@/features/import_export_histories/constants';
import { useCallback, useEffect, useState } from 'react';

export const useImportExportHistoriesPolling = () => {
  const [pollingStartedAt, setPollingStartedAt] = useState<number | null>(null);
  const isPollingEnabled = pollingStartedAt !== null;

  const startPolling = useCallback(() => setPollingStartedAt(Date.now()), []);
  const resetPollingTimer = useCallback(
    () => setPollingStartedAt(Date.now()),
    []
  );
  const cancelPolling = useCallback(() => setPollingStartedAt(null), []);

  useEffect(() => {
    if (!pollingStartedAt) return;
    const timer = setTimeout(cancelPolling, MAX_POLLING_DURATION_MS);
    return () => clearTimeout(timer);
  }, [pollingStartedAt, cancelPolling]);

  return { isPollingEnabled, startPolling, resetPollingTimer, cancelPolling };
};
